import { combineReducers } from "redux";
import grievanceReducer from "./grievanceReducer";
export default combineReducers({
  grievances: grievanceReducer,
});
